import { lazy, Suspense } from 'react';
import If from 'components/If';
import Spin from 'components/Spin';
import useCardExpiryReminder from 'hooks/useCardExpiryReminder';

const CardExpiryReminderModal = lazy(
  () => import('pages/dashboard/CardExpiryReminderModal'),
);

/* Layout-level home of the Card Expiry Reminder modal.
 *
 * Runs `useCardExpiryReminder` once per authenticated page load;
 * the hook opens the modal for any of three signals:
 *   1. Primary + billable user whose saved card expires within 90d.
 *   2. Discover employee whose Zuora account was never created
 *      (`accountFound: false`).
 *   3. Explicit request via `setCardExpiryModalRequested(true)` —
 *      what the Discover proprietary banner's "Update now" link
 *      dispatches.
 *
 * Kept at layout (not dashboard) so the banner click works from any
 * page. Cheap — the fetches inside the hook dedupe on their loaded
 * flags, so a page-to-page navigation doesn't re-fire them. */
function CardExpiryOnDemand() {
  const { isOpen, close, skipToPayment } = useCardExpiryReminder();

  return (
    <If condition={isOpen}>
      <Suspense fallback={<Spin fullscreen />}>
        <CardExpiryReminderModal
          isOpen={isOpen}
          skipToPayment={skipToPayment}
          onClose={close}
        />
      </Suspense>
    </If>
  );
}

export default CardExpiryOnDemand;
